import {
  useApi,
  type GetGovMapGroupsResponseDto,
  type GovmapGroupFilteringDtoOptions,
  type GovmapGroupSortingDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

type GetGovmapGroupsQueryParameters = {
  sort?: GovmapGroupSortingDtoOptions;
  filter?: GovmapGroupFilteringDtoOptions;
  enabled?: boolean;
};

export function useGovmapGroups(props: GetGovmapGroupsQueryParameters) {
  const { sort = {}, filter = {}, enabled = true } = props;

  const api = useApi();

  return useQuery<GetGovMapGroupsResponseDto[], ExtendedAxiosError>({
    queryKey: ['govmap-groups', sort, filter, enabled],
    queryFn: () =>
      api.govmapGroupsApi.getGovMapGroups(sort, filter).then((r) => r.data),
    enabled,
    meta: {
      handleError: true,
    },
  });
}
